import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TinyColor } from '@ctrl/tinycolor';
import { Storage } from '@ionic/storage-angular';
import { watch } from 'ionicons/icons';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storageOn = false;
  private _storage: Storage | null = null;
  public showMenu: boolean = false;
  public alertReturn = '';
  public token: string = '';
  public email = '';
  public password='';
  public user: any;
  public users: any;
  public device: any;
  public lan:string | undefined;
  public playerMode: boolean = false;
  public adminAvailable: boolean = false;
  public config = [{id:1,name:'cha_d', data1: 5, data1val:'days'},{id:2,name:'tra_d', data1: 300, data1val:'seconds'},];
  public ageRecommendations = ['all', '5-8', '9-10', '11-12', '13+'];
  public messageModes = ['once', 'daily', 'weekly', 'monthly'];
  public selectedUser: any;
  public selectedTeam: any = {team: {id: 0, name: ''}, teamChallenges:[{playerlist:[], statusarr:[], updatedat:[], status:'', players:'', date:''} ] };
  public selectedTeamPlayers: any;
  public selectedPlayer: any;
  public selectedTeamChallenge:any;
  public selectedClub: any = {id:0, name:'', clublogo:''};
  public originalTeamChallenges: any;
  public flagUrl: string = '';
  public param:string | null = null;

  public selectedPracticeVideo: any= {id:-1, name:'', title:'', videourl:''};;
  public selectedChallengeVideo: any = {id:-1, name:'', title:'', videourl:''};
  public selectedChallengePracticeVideo: any= {id:-1, title:'', name:'', videourl:''};

  public selectedVideo: any ;

  public selectedVideoType='';

  public selectedTeamEvent: any = {name: '', location:'', start_time: new Date(new Date().toString().split('GMT')[0]+' UTC').toISOString().slice(0,-8), duration:60, type:'', lineup:[]};

  public challenges: any;
  public selectedChallenge: any ={id:-1, name:'',description:'', class:'' };
  // public challengePractices: any;
  public selectedChallengePracticeList: any = [];
  public selectedChallengePractice: any ={id:-1, name:'',description:'' };
  public challengeResults: any;
  public teamChallResults: any;
  public selectedChallengeResult: any;
  public myActiveChallenges: any = [];
  public timerServiceCounter: number = 0;
  public trainingDone: boolean = false;
  public trainingArr: any = [];
  public ownTrainingArr:any = [];
  public videoId:number | null= null;
  public challengeId:number | null= null;
  public messages: any = [];
  public newMessages: any = [];

  public roles = ['admin','editor' , 'user'];
  public classList = [
    {id:0,name:'Kuljettaminen'},
    {id:1,name:'Käännökset'},
    {id:2,name:'Suunnanmuutokset'},
    {id:3,name:'Ohittaminen / harhauttaminen'},
    {id:4,name:'Syöttäminen'},
    {id:5,name:'Laukaukset ja maalinteko'},
    {id:6,name:'Ensimmäinen kosketus'},
    {id:7,name:'Palloleikit'},
    {id:8,name:'Kikat ja temput'},
    {id:9,name:'Yhdistelmäharjoitteet'},
    {id:10,name:'Harjoittelen omassa huoneessa'},
    {id:11,name:'Koordinaatio, fysiikka ja nopeat jalat'},
  ];
  public goalList =[
    {id:0,name:'aikatavoite'},
    {id:1,name:'määrätavoite'},
  ];
  public modes = [    
    {id:0,name:'tra_7min'},
    {id:0,name:'tra_15min'},
    {id:1,name:'cha_5d'},
    {id:2,name:'c_mode'},

  ];
  public clubModes = [
    'Basic mode',

  ];
  public demoList = [
    {id:0,name:'proccess1'},
    {id:1,name:'proccess2'},
    {id:2,name:'trainer_mode'},
    {id:3,name:'coach_mode'},
    {id:4,name:'player_mode'},
    {id:5,name:'none'},
  ];
  public positions = [
    'GOALKEEPER',
    'DEFENDER',
    'MIDFIELDER',
    'FORWARD'
    
  ];
  public eventTypes = ['training', 'match', 'fysical', 'practice'];
  public eventThemes = ['default', 'dark', 'nature', 'ocean', 'sunset', 'forest', 'desert', 'space', 'cityscape'];
  public durationTypes = ['min', '%'];
  public login: boolean = true;
  public role: string = 'user';
  public platform: string = 'web';
  public videomakers: any;
  public translates: any = [{language:'Suomi', code:'fi'}, {language:'English', code:'en'}];
  public languages: any;
  public page: string = '';
  public age:number = 0;
  public ageClass:number = 1;
  public coach:any = [];
  public player:any;
  public myTeam: any = 0;
  public myClub:any = 0;
  public privacyPolicyLink: string = 'https://treeniappi.com/privacy-policy/';

  public clubs: any;
  public teams: any;
  public players: any;
  public video2upload: any;
  public coachModeAvailable: boolean = false;
  public coachMode: boolean = false;
  public messageType = '';
  public refreshCalendar: boolean = false;

  public translation={
  create_pt:'LUO UUSI KÄYTTÄJÄ',
  lan_t:'Kieli: ',
  country_t:'Maa: ',
  email_t:'S-posti: ',
  name_t:'Nimi: ',
  birth_t:'Syntymävuosi: ',
  password_t:'Salasana:',
  rePasswrd_t:'Kirjoita salasana uudelleen: ',
  shirt_t:'Pelinumero#',
  color_t:'Teemaväri: ',
  accept_t:'Hyväksy palvelun käyttöehdot ',
  privacy_t:'tietosuojaseloste',
  deleteAccount_t:'POISTA OMA TILISI',
  yes_t: 'KYLLÄ',
  no_t: 'EI',
  //login page
  loginPage_ht:'KIRJAUTUMISSIVU',
  login_pt:'KIRJAUDU SISÄÄN',
  forgot_t:'Unohdin salasanan',
  logingIn_t:'kirjaudutaan sisään...',
  noInternet_t:'Ei pystytä kirjautumaan sisään. Internetyhteys ei toimi tai järjestelmä on tilapäisesti huollettavana.',
  //forgot page
  forgotPage_t:'salasanan vaihtosivu',
  forgot_ht:'Unohdetun salasanan palautus',
  find_t:'Etsi salasanan palautuskoodi s-postistasi. Tarkasta myös roskapostikansio.',
  changeCode_t:'Salasanan vaihtokoodi:',
  newPass_t:'Uusi salasana: ', 
  changePass_pt:'VAIHDA SALASANA',
  //tabs
  challenge_ht:'HAASTEET',
  profile_ht:'PROFIILI',
  calendar_ht:'KALENTERI',
  //tab2
  playerCard_t:'PELAAJAKORTTI',
  changeProfilePic_t:'VAIHDA PROFIIILIKUVA',
  joinTeam_t:'Näytä tämä QR-koodi valmentajalle liittyäksesi joukkueeseen!',
  //tab1 = my active challenges
  my_active_challenges_t:'MINUN HAASTEET',
  selectChall_t:'VALITSE HAASTE',
  letsTrain_t:'TREENATAAN HAASTEESEEN',
  hidePrac_t:'PIILOTA HARJOITTEET',
  showChall_t:'NÄYTÄ HAASTE',
  hideChall_t:'PIILOTA HAASTE',
  challName_t:'HAASTEEN NIMI: ',
  challDesc_t:'HAASTEEN KUVAUS: ',
  pracName_t:'HARJOITTEEN NIMI: ',
  pracDesc_t:'HARJOITTEEN KUVAUS: ',
  //calendar
  days_t:['MA','TI','KE','TO','PE','LA','SU'],
  //lineup
  lineup_t:'kokoonpano', 
  lineupForm_t:'pelimuoto',
  //team
  club_t:'SEURA: ',
  team_t:'JOUKKUE: ',
  roster_t:'pelaajat',
  //selectpic
  selectProfilePic_t:'VALITSE PROFIIILIKUVA',
  takeNewPic_t:'OTA UUSI KUVA',
  selectPic_t:'VALITSE KUVA',
  uploadPic_t:'LATAA KUVA PROFIILIIN',
  uploadingPic_t: 'Ladataan kuvaa profiiliin ...',

  //tab3
  trainings_ht:'TREENIT',
  chooseTrainning_t:'Valitse treeni',
  watchVideo_t:'Katso treeni',
  trainNow_t:'Treenaa vähintään kellon mukaan',

  chooseTraining_t:'Valitse treeni!',
  watchTraining_t:'Katso miten treenata!', 
  trainOngoing_t:'Treeni meneillään: ', 
  trainingTime_t:'Treenin kesto: ',
  startTrainnig_t:'Aloita harjoitus' ,  
  finnishTraining_t: 'Voit halutessasi vaihtaa harjoitusta!', 

  //sharevideo
  shareVideo_t:'JAA TREENIVIDEO',
  shareVideoText_t:'Jaa treenivideo muiden käyttäjien kanssa! Voit valita videon tyypin ja kertoa vapaasti videosta lisää. Näin video on palvelun hyödynnettävissä. Sinulla säilyy videon hallinta. Sinulla on mahdolllista halutesssasi pyytää videon poistoa s-postilla. Videon julkaiseminen menee joitakin päiviä, koska video tarkastetaan Treeniapin toimesta.',
  selectVideo_t:'VALITSE VIDEO JAKOA VARTEN',
  selectVideoType_t:'VALITSE VIDEON KÄYTTÖOIKEUS',
  uploadVideo_t:'LATAA VIDEO',
  uploadingVideo_t:'Ladataan videota palveluun ...',
  videoTitle_t:'VIDEON NIMI:',
  freeText_t:'VAPAA TEKSTI:',
  freeUse_t: 'Saa käyttää vapaasti',
  teamUse_t: 'Saa käyttää vain omassa joukkueessa',
  clubUse_t: 'Saa käyttää vain omassa seurassa',
  drag8drop_t:'Drag & drop or',
  browse_t:'browse',
  Ufiles_t:'your video',
  pleaseSelectVideoFile: 'Ole hyvä ja valitse videotiedosto.',
  // Post page
  post_t:'VIESTIEN LÄHETYS',
  createPost_t:'LUO VIESTI',
  editPost_t:'MUOKKAA VIESTIÄ',
  deletePost_t:'POISTA VIESTI',
  //message page
  message_t:'VIESTIT',
  noVideo_t:'Videota ei saatavilla.',
  sender_t:'Lähettäjä',
  videoLink_t:'Videolinkki',
  showLatestMessages_t:'Näytä uusimmat viestit',
  showOlderMessages_t:'Näytä vanhemmat viestit',
  toMessages_t:'Siirry viesteihin',
  youHaveNewMessages_t:'Sinulla on uusia viestejä! Haluatko tarkastella niitä nyt?',
  newMessages_t:'Uusia viestejä!',
  noNewMessages_t:'Ei uusia viestejä.',

  //about
  about_t:'TIETOJA',
  aboutNote_t:'Treenaa jalkapalloa innostavien videoiden avulla.',
  close_t:'Sulje selain',
  //app
  user_t:'KÄYTTÄJÄ: ',
  userPage_t:'KÄYTTÄJÄN ASETUKSET',
  teamPage_t: 'JOUKKUE',
  logout_t:'KIRJAUDU ULOS',
  //alerts
  passNotMatches:'Salanat eivät täsmää.',
  passNot_t:'Salasana toistettu väärin tai liian lyhyt salasana.',
  loginFailed_t:'Sisäänkirjautuminen epäonnistui.',
  wrongUser_t:'Virheellinen käyttäjä tai salasana.',
  errorGVideos_t:'Videoita ei saatu ladattua.',
  errorGVideoMakers_t:'Videon tekijöitä ei saatu ladattua.',
  noAccont_t:'Tällä s-postilla ei ole luotu tiliä.',
  passwordChFailed_t:'Salasanan vaihto epäonnistui.',
  passwordFRepeat_t: 'Salasana toistettu väärin.',
  pleaseAccept_t:'Hyväksy vielä palvelun ehdot.',
  invadidEmail_t:'Ole hyvä ja käytä toimivaa s-postia.',
  deletaAccountAnoncement_t:'Tämä toiminto poistaa tilisi ja kaiken sen sisältämän tiedon!',
  deleteMessage_t:'Käyttäjänpoiston pyyntö lähetetty ylläpitoon. Tili poistetaan viikon 7 päivän kuluttua. Jos haluat perua poistamisen ole yhteydessä ylläpitoon: jtmuti@outlook.com',
  countryNotValid:'Valitse maa, niin saat lipun näkyviin pelaajakortissasi.',
  //demo
  demoNo_t:'Tämä toiminto ei ole käytössä demoversiossa.',
  tryDemo_t:'Kokeile demotilillä',
  selectDemo_t:'Valitse demotili: ',
  //notification
  openVideo_t:'Avaa Video',
  openChall_t:'Avaa Haaste',
  later_t:'Myöhemmin'
};

  public practiceVideos:any[]= [];
  //  = [{
  //   "videourl": "https://youtu.be/dIyhUE1Jt9s",
  //   "title": "kokelu2__",
  //   "reason": [
  //       1,
  //       2
  //   ],
  //   "sport": [
  //       1,
  //       2
  //   ],
  //   "trainingcategory": [
  //       1,
  //       2
  //   ],
  //   "physicality": [
  //       1,
  //       2
  //   ],
  //   "balltraining": [
  //       1,
  //       2
  //   ],
  //   "playerneed": [
  //       1,
  //       2
  //   ],
  //   "trainingfacility": [
  //       1,
  //       2
  //   ],
  //   "agerecomendation": [
  //       1,
  //       2
  //   ],
  //   "videomaker": "tekijä",
  //   "timeofcreation": "2024-01-12T12:54:18.128Z"
  // },{
  //   "videourl": "https://youtu.be/dIyhUE1Jt9s",
  //   "title": "kokelu1__",
  //   "reason": [
  //       1,
  //       2
  //   ],
  //   "sport": [
  //       1,
  //       2
  //   ],
  //   "trainingcategory": [
  //       1,
  //       2
  //   ],
  //   "physicality": [
  //       1,
  //       2
  //   ],
  //   "balltraining": [
  //       1,
  //       2
  //   ],
  //   "playerneed": [
  //       1,
  //       2
  //   ],
  //   "trainingfacility": [
  //       1,
  //       2
  //   ],
  //   "agerecomendation": [
  //       1,
  //       2
  //   ],
  //   "videomaker": [1],
  //   "timeofcreation": "2024-01-12T12:54:18.128Z"
  // }];
  public selectedTranslation:number = 0;
  public translate :any; //= {"language": "FINLAND",

//   "reason": [
//       "videon tyyppi",
//       "kaikki",
//       "mainos",
//       "opetusvideo",
//       "harjoittelu",
//       "joukkueharjoitus"
//   ],
//   "sport": [
//       "urheilulaji",
//       "kaikki",
//       "jalkapallo",
//       "salibandy"
//   ],
//   "trainingcategory": [
//       "harjoitekategoria",
//       "kaikki",
//       "pallon käsittely",
//       "syötöt",
//       "fysiikka",
//       "other"
//   ],
//   "physicality": [
//       "fyysisyys",
//       "ei",
//       "alkulämpö",
//       "tempo",
//       "palautuminen",
//       "koordinaatio",
//       "ketteryys",
//       "venyttely",
//       "spurtit",
//       "muu"
//   ],
//   "balltraining": [
//       "pallotekniikka",
//       "heikompi jalka",
//       "lyhyet syötöt",
//       "pitkät syötöt",
//       "laukaukset",
//       "pallolliset käännökset",
//       "syötön ajoitus"
//   ],
//   "playerneed": [
//       "pelaajien määrä",
//       "yksin",
//       "pari",
//       "pieni porukka",
//       "joukkue"
//   ],
//   "trainingfacility": [
//       "harjoitus olosuhteet",
//       "takapiha",
//       "sisätila",
//       "pikkukenttä",
//       "täysi kenttä"
//   ],
//   "agerecomendation": [
//       "ikä",
//       "kaikki",
//       "alle 16",
//       "allen 13",
//       "alle 10"
//   ],
//   "videomaker": ["videon tekijä", "keisari", "tekijä"],
//   };

  

  constructor(
    private storage: Storage) { 
    //this.init();

  }
  public async init() {
    console.log('storage.service.ts: init()');
    this.storageOn = true;
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    const storage = await this.storage.create();
    this._storage = storage;

  }
  public is(){
    //console.log('cred: ',this.get('email'), this.get('password'));
    if(this.storageOn || (this.get('email') && this.get('password'))){
      return true;
    }
    else{
      this.init();
      return false;
    }
  }
  // Create and expose methods that users of this service can
  // call, for example:
  public set(key: string, value: any) {
    // this.storage.set(key,value);
    localStorage.setItem(key, value);
    //this._storage?.set(key, value);
  }
  public get(key:string){
    // return this.storage.get(key);
     //return this._storage?.get(key);
     const out = localStorage.getItem(key);
     return out?out:'';
  }
  public clear() {
    //this._storage?.clear();
    // this.storage.clear();
    localStorage.clear();
  }
  public setTranslation(lan:any){
    console.log('lan: ', lan);
    if(lan === 'fi'){
      //signup & user  page
      this.translation.create_pt='LUO UUSI KÄYTTÄJÄ';
      this.translation.lan_t='Kieli: ';
      this.translation.country_t='Maa: ';
      this.translation.email_t='S-posti: ';
      this.translation.name_t='Nimi: ';
      this.translation.birth_t='Syntymävuosi: ';
      this.translation.password_t='Salasana:';
      this.translation.rePasswrd_t='Kirjoita salasana uudelleen: ';
      this.translation.shirt_t='Pelinumero#';
      this.translation.color_t='Teemaväri: ';
      this.translation.accept_t='Hyväksy palvelun käyttöehdot ';
      this.translation.privacy_t='tietosuojaseloste';
      this.translation.deleteAccount_t='POISTA OMA TILISI';
      this.translation.yes_t='KYLLÄ';
      this.translation.no_t='EI';
      //login page
      this.translation.loginPage_ht='KIRJAUTUMINEN';
      this.translation.login_pt='KIRJAUDU SISÄÄN';
      this.translation.forgot_t='Unohdin salasanan';
      this.translation.logingIn_t='kirjaudutaan sisään...';
      this.translation.noInternet_t='Ei pystytä kirjautumaan sisään. Internetyhteys ei toimi tai järjestelmä on tilapäisesti huollettavana.';
      //forgot page
      this.translation.forgotPage_t='salasanan vaihtosivu';
      this.translation.forgot_ht='Unohdetun salasanan palautus';
      this.translation.find_t='Etsi salasanan palautuskoodi s-postistasi. Tarkasta myös roskapostikansio.';
      this.translation.changeCode_t='Salasanan vaihtokoodi:';
      this.translation.newPass_t='Uusi salasana: '; 
      this.translation.changePass_pt='VAIHDA SALASANA';
      //tabs
      this.translation.challenge_ht='HAASTEET';
      this.translation.profile_ht='PROFIILI';
      this.translation.calendar_ht='KALENTERI';
      //tab2
      this.translation.playerCard_t='PELAAJAKORTTI';
      this.translation.changeProfilePic_t='VAIHDA PROFIIILIKUVA';
      this.translation.joinTeam_t='Näytä tämä QR-koodi valmentajalle liittyäksesi joukkueeseen!';
      //tab1 = my active challenges
      this.translation.my_active_challenges_t='MINUN HAASTEENI';
      this.translation.selectChall_t='VALITSE HAASTE';
      this.translation.letsTrain_t='TREENATAAN HAASTEESEEN';
      this.translation.showChall_t='NÄYTÄ HAASTE';
      this.translation.challName_t='HAASTEEN NIMI: ';
      this.translation.challDesc_t='HAASTEEN KUVAUS: ';
      this.translation.pracName_t='HARJOITTEEN NIMI: ';
      this.translation.pracDesc_t='HARJOITTEEN KUVAUS: ';
      this.translation.hidePrac_t='PIILOTA HARJOITTEET';
      this.translation.hideChall_t='PIILOTA HAASTE';

      //selectpic
      this.translation.selectProfilePic_t='VALITSE PROFIIILIKUVA';
      this.translation.takeNewPic_t='OTA UUSI KUVA';
      this.translation.selectPic_t='VALITSE KUVA';
      this.translation.uploadPic_t='LATAA KUVA PROFIILIIN';
      this.translation.uploadingPic_t='Ladataan kuvaa profiiliin ...';

      //tab3
      this.translation.trainings_ht='TREENIT';
      this.translation.chooseTraining_t = 'Valitse treeni!';
      this.translation.watchTraining_t = 'Katso miten treenata!'; 
      this.translation.trainOngoing_t = 'Treeni meneillään: '; 
      this.translation.trainingTime_t = 'Treenin kesto: ';
      this.translation.startTrainnig_t = 'Aloita harjoitus' ;  
      this.translation.finnishTraining_t = 'Voit halutessasi vaihtaa harjoitusta!';
      //calendar
      this.translation.days_t=['MA','TI','KE','TO','PE','LA','SU'];
      //lineup
      this.translation.lineup_t='kokoonpano';
      this.translation.lineupForm_t='pelimuoto';
        //team
      this.translation.club_t = 'SEURA: ';
      this.translation.team_t = 'JOUKKUE: ';
      this.translation.roster_t = 'Pelaajat'
      //share video

      this.translation.shareVideo_t='JAA TREENIVIDEO';
      this.translation.shareVideoText_t='Jaa treenivideo muiden käyttäjien kanssa! Voit valita videon tyypin ja kertoa vapaasti videosta lisää. Näin video on palvelun hyödynnettävissä. Sinulla säilyy videon hallinta. Sinulla on mahdolllista halutesssasi pyytää videon poistoa s-postilla. Videon julkaiseminen menee joitakin päiviä, koska video tarkastetaan Treeniapin toimesta.';
      this.translation.selectVideo_t='VALITSE VIDEO JAKOA VARTEN';
      this.translation.selectVideoType_t='VALITSE VIDEON KÄYTTÖOIKEUS';
      this.translation.uploadVideo_t='LATAA VIDEO';
      this.translation.uploadingVideo_t='Ladataan videota palveluun ...';
      this.translation.videoTitle_t='VIDEON NIMI:';
      this.translation.freeText_t='VAPAA TEKSTI:';
      this.translation.freeUse_t='Näkyy kaikille käyttäjille';
      this.translation.teamUse_t='Saa käyttää vain omassa joukkueessa';
      this.translation.clubUse_t='Saa käyttää vain omassa seurassa';
      this.translation.drag8drop_t='Raahaa & pudota tai ';
      this.translation.browse_t='nouda';
      this.translation.Ufiles_t=' videosi';
      this.translation.pleaseSelectVideoFile='Ole hyvä ja valitse videotiedosto.';
        // Post page
      this.translation.post_t='VIESTIEN LÄHETYS',
      this.translation.createPost_t='LUO VIESTI',
      this.translation.editPost_t='MUOKKAA VIESTIÄ',
      this.translation.deletePost_t='POISTA VIESTI',
      //message page
      this.translation.message_t='VIESTIT';
      this.translation.noVideo_t='Videota ei saatavilla.';
      this.translation.sender_t='Lähettäjä';
      this.translation.videoLink_t='Videolinkki';
      this.translation.showLatestMessages_t='Näytä uusimmat viestit';
      this.translation.showOlderMessages_t='Näytä vanhemmat viestit';
      this.translation.toMessages_t='Siirry viesteihin';
      this.translation.youHaveNewMessages_t='Sinulla on uusia viestejä! Haluatko tarkastella niitä nyt?';
      this.translation.newMessages_t='Uusia viestejä!';
      this.translation.noNewMessages_t='Ei uusia viestejä.';
      //about
      this.translation.about_t='TIETOJA';
      this.translation.aboutNote_t='Treenaa jalkapalloa innostavien videoiden avulla.';
      this.translation.close_t='Sulje selain';
      //app
      this.translation.user_t='KÄYTTÄJÄ: ';
      this.translation.userPage_t='KÄYTTÄJÄN ASETUKSET';
      this.translation.teamPage_t= 'JOUKKUE';
      this.translation.logout_t='KIRJAUDU ULOS';
        //alerts
        this.translation.passNotMatches='Salanat eivät täsmää.';
        this.translation.passNot_t='Salasana toistettu väärin tai liian lyhyt salasana.';
        this.translation.loginFailed_t='Sisäänkirjautuminen epäonnistui.';
        this.translation.wrongUser_t='Virheellinen käyttäjä tai salasana.';
        this.translation.errorGVideos_t='Videoita ei saatu ladattua.';
        this.translation.errorGVideoMakers_t='Videon tekijöitä ei saatu ladattua.';
        this.translation.noAccont_t='Tällä s-postilla ei ole luotu tiliä.';
        this.translation.passwordChFailed_t='Salasanan vaihto epäonnistui.';
        this.translation.passwordFRepeat_t= 'Salasana toistettu väärin.';
        this.translation.pleaseAccept_t='Hyväksy vielä palvelun ehdot.';
        this.translation.invadidEmail_t='Ole hyvä ja käytä toimivaa s-postia.';
        this.translation.deletaAccountAnoncement_t='Tämä toiminto poistaa tilisi ja kaiken sen sisältämän tiedon ';
        this.translation.deleteMessage_t='Käyttäjänpoiston pyyntö lähetetty ylläpitoon. Tili poistetaan viikon 7 päivän kuluttua. Jos haluat perua poistamisen ole yhteydessä ylläpitoon: jtmuti@outlook.com';
        this.translation.countryNotValid='Valitse maa, niin saat lipun näkyviin pelaajakortissasi.';
        //demo
        this.translation.demoNo_t='Tämä toiminto ei ole käytössä demoversiossa.';
        this.translation.tryDemo_t='Kokeile demotilillä';
        this.translation.selectDemo_t='Valitse demotili: ';
        //notification
        this.translation.openVideo_t='Avaa Video';
        this.translation.openChall_t='Avaa Haaste';
        this.translation.later_t='myöhemmin';

        this.classList = [
          {id:0,name:'Kuljettaminen'},
          {id:1,name:'Käännökset'},
          {id:2,name:'Suunnanmuutokset'},
          {id:3,name:'Ohittaminen / harhauttaminen'},
          {id:4,name:'Syöttäminen'},
          {id:5,name:'Laukaukset ja maalinteko'},
          {id:6,name:'Ensimmäinen kosketus'},
          {id:7,name:'Palloleikit'},
          {id:8,name:'Kikat ja temput'},
          {id:9,name:'Yhdistelmäharjoitteet'},
          {id:10,name:'Harjoittelen omassa huoneessa'},
          {id:11,name:'Koordinaatio, fysiikka ja nopeat jalat'},
        ];


    }
    else{
      //signup & user  page
      this.translation.create_pt='CREATE NEW USER';
      this.translation.lan_t='Language: ';
      this.translation.country_t='Country: ';
      this.translation.email_t='Email: ';
      this.translation.name_t='Name: ';
      this.translation.birth_t='Birth year: ';
      this.translation.password_t='Password:';
      this.translation.rePasswrd_t='Re-type password: ';
      this.translation.shirt_t='Shirt number#';
      this.translation.color_t='Theme color: ';
      this.translation.accept_t='Accept service agreement';
      this.translation.privacy_t='Privacy Policy';
      this.translation.deleteAccount_t='DELETE YOUR ACCOUNT';
      this.translation.yes_t='YES';
      this.translation.no_t='NO';
      //login page
      this.translation.loginPage_ht='LOGIN PAGE';
      this.translation.login_pt='LOGIN';
      this.translation.forgot_t='Forgot password';
      this.translation.logingIn_t = 'logging in...';
      this.translation.noInternet_t = 'Unable to sign in. Please check that you have functional internet connection. Sevice can also be under maintenance.';

      //forgot page
      this.translation.forgotPage_t='Password change page';
      this.translation.forgot_ht='Forgot password return';
      this.translation.find_t='Find your password recovery code in your email. Check also spam folder.';
      this.translation.changeCode_t='Password change code:';
      this.translation.newPass_t='New password: '; 
      this.translation.changePass_pt='CHANGE PASSWORD';
      //tabs
      this.translation.challenge_ht='CHALLENGES';
      this.translation.profile_ht='PROFILE';
      this.translation.calendar_ht='CALENDAR';
      //tab2
      this.translation.playerCard_t='PLAYER CARD';
      this.translation.changeProfilePic_t='CHANGE PROFILE PICTURE';
      this.translation.joinTeam_t='Show this QR-code to coach to join the team!';
      //tab1 = my active challenges
      this.translation.my_active_challenges_t='MY CHALLENGES';
      this.translation.selectChall_t='SELECT CHALLENGE';
      this.translation.letsTrain_t='LET\'S TRAIN TO CHALLENGE';

      this.translation.showChall_t='SHOW CHALLENGE';
      this.translation.challName_t='CHALLENGE NAME: ';
      this.translation.challDesc_t='CHALLENGE DESCRIPTION: ';
      this.translation.pracName_t='PRACTICE NAME: ';
      this.translation.pracDesc_t='PRACTICE DESCRIPTION: ';
      this.translation.hidePrac_t='HIDE PRACTICES';
      this.translation.hideChall_t='HIDE CHALLENGE';
      //team
      this.translation.club_t = 'CLUB: ';
      this.translation.team_t = 'TEAM: ';
      this.translation.roster_t = 'roster'

      //selectpic
      this.translation.selectProfilePic_t='SELECT PROFILE PICTURE';
      this.translation.takeNewPic_t='TAKE NEW PICTURE';
      this.translation.selectPic_t='SELECT PICTURE';
      this.translation.uploadPic_t='UPLOAD PICTURE TO PROFILE';
      this.translation.uploadingPic_t='Uploading picture to profile ...';
      //tab3
      this.translation.trainings_ht='TRAININGS';
      this.translation.chooseTraining_t = 'Select training!';
      this.translation.watchTraining_t = 'Check how to train!'; 
      this.translation.trainOngoing_t = 'Training ongoing: '; 
      this.translation.trainingTime_t = 'Training time: ';
      this.translation.startTrainnig_t = 'Start training' ;  
      this.translation.finnishTraining_t = 'Now you can select new training!'; 
      //calendar
      this.translation.days_t=['MO','TU','WE','TH','FR','SA','SU'];
      //lineup
      this.translation.lineup_t='lineup';
      this.translation.lineupForm_t='Formation';
      //share video
      this.translation.shareVideo_t='SHARE VIDEO';
      this.translation.shareVideoText_t='Share your training video with other users! You can tell more about the video and select video type. This way the video is available in the service. You keep the control of the video. You can request deletion of the video by email if you want. Publishing the video takes few days, because the video is checked by Treeniappi.';
      this.translation.selectVideo_t='SELECT VIDEO TO SHARE';
      this.translation.selectVideoType_t='SELECT VIDEO TYPE OF USAGE';
      this.translation.uploadVideo_t='UPLOAD VIDEO';
      this.translation.uploadingVideo_t='Uploading video to service ...';
      this.translation.pleaseSelectVideoFile='Please select a video file.';

      this.translation.videoTitle_t='VIDEO TITLE:';
      this.translation.freeText_t='FREE TEXT ABOUT VIDEO:';
      this.translation.freeUse_t='Available to all users';
      this.translation.teamUse_t='Team use only';
      this.translation.clubUse_t='Club use only';
      this.translation.drag8drop_t='Drag & drop or ';
      this.translation.browse_t='browse';
      this.translation.Ufiles_t=' your video';
      // Post page
      this.translation.post_t='MESSAGE SENDING',
      this.translation.createPost_t='CREATE MESSAGE',
      this.translation.editPost_t='EDIT MESSAGE',
      this.translation.deletePost_t='DELETE MESSAGE',
      //message page
      this.translation.message_t='MESSAGES';
      this.translation.noVideo_t='No video available.';
      this.translation.sender_t='Sender';
      this.translation.videoLink_t='Video link';
      this.translation.showLatestMessages_t='Show latest messages';
      this.translation.showOlderMessages_t='Show older messages';
      this.translation.toMessages_t='Go to messages';
      this.translation.youHaveNewMessages_t='You have new messages! Do you want to check them now?';
      this.translation.newMessages_t='New messages!';
      this.translation.noNewMessages_t='No new messages.';
      //about
      this.translation.about_t='ABOUT';
      this.translation.aboutNote_t='Train football with inspiring videos.';
      this.translation.close_t='Close browser';
      //app
      this.translation.user_t='USER: ';
      this.translation.userPage_t='USER PAGE';
      this.translation.teamPage_t= 'TEAM';
      this.translation.logout_t='LOGOUT';
      //alerts
      this.translation.passNotMatches = 'Passwords do not matches.';
      this.translation.passNot_t='The passwords do not match or too short password!';
      this.translation.loginFailed_t='Login failed';
      this.translation.wrongUser_t='Wrong user or password.';
      this.translation.errorGVideos_t='Error geting videos';
      this.translation.errorGVideoMakers_t='Error geting video makers';
      this.translation.noAccont_t='No account created with this email.';
      this.translation.passwordChFailed_t='Password change failed';
      this.translation.passwordFRepeat_t= 'Passwords does not match with Re-type password.';
      this.translation.pleaseAccept_t='Please accept the terms of service.';
      this.translation.invadidEmail_t='Please use propper email address.';
      this.translation.deletaAccountAnoncement_t='Are you sure you want to DELDETE your account and all the information in it';
      this.translation.deleteMessage_t='User account remove proccess is started. Account will be deleted in 7 days. If you want to cancel removement please contact administration: jtmuti@outlook.com';
      this.translation.countryNotValid='Please select country to show flag in player card.';
      //demo
      this.translation.demoNo_t="Demo user can't save changes.";
      this.translation.tryDemo_t='Try demo user';
      this.translation.selectDemo_t='Select demo account: ';
      //notifications
      this.translation.openVideo_t='Open Video';
      this.translation.openChall_t='Open Challenge';
      this.translation.later_t='Later';


      this.classList = [
        {id:0,name:'Dribling'},
        {id:1,name:'Turning'},
        {id:2,name:'Change of direction'},
        {id:3,name:'Overtaking / Deceiving'},
        {id:4,name:'Passing'},
        {id:5,name:'Shooting and scoring'},
        {id:6,name:'First touch'},
        {id:7,name:'Ball games'},
        {id:8,name:'Skills and tricks'},
        {id:9,name:'Combination exercises'},
        {id:10,name:'Training in my room'},
        {id:11,name:'Coordination, physics and fast feet'},
      ];
      this.privacyPolicyLink = 'https://treeniappi.com/gb/privacy-policy/';
    }
    console.log('translation: ',this.translation);
  }
  
  

  
}
